import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import Panel from '../../../../../../components/angle/Panel';
import { formInputValidation } from '../../../../../../services/helper/form-helper';
import AddUserForm from '../../components/UserForm';
import { fetchAccounts } from '../../../../../../services/redux/employee/account/actions';
import { fetchClientsByAccount } from '../../../../../../services/redux/employee/clientInformation/actions';
import { fetchRoles } from '../../../../../../services/redux/employee/role/actions';
import {
    addNewUser,
    updateAddNewUserPayload
} from '../../../../../../services/redux/employee/user/actions';
class AddUser extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }
    componentDidMount() {
        let { fetchAccounts, fetchRoles } = this.props;
        fetchAccounts();
        fetchRoles();
    }
    onSaveClick = () => {
        let { user, history, addNewUser } = this.props;
        let payload = {
            ...user.addNewUserData, 
            userModelId: user.addNewUserData.email
        };
        if (formInputValidation(this.formRef.current)) {
            addNewUser(payload).then(response => {
                if (response.status === 200) {
                    history.push('/sign-up');
                }
            });
        }
    };

    render() {
        let {
            user,
            updateAddNewUserPayload,
            fetchClientsByAccount,
            accounts,
            clientInformation,
            roles
        } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        return (
            <div>
                <Panel
                    showHeader
                    header="Add User"
                    showFooter
                    footerComponents={saveButton}
                >
                    <div>
                        <AddUserForm
                            userData={user.addNewUserData}
                            updateUserData={updateAddNewUserPayload}
                            fetchAccountList={fetchClientsByAccount}
                            accountList={accounts.accounts}
                            clientList={clientInformation.clients}
                            roleList={roles.roles}
                            formRef={this.formRef}
                        />
                    </div>
                </Panel>
                {accounts.fetching && <Spinner />}
                {clientInformation.fetching && <Spinner />}
                {roles.fetching && <Spinner />}
                {user.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.employee.user,
    accounts: state.employee.account,
    clientInformation: state.employee.clientInformation,
    roles: state.employee.role
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addNewUser,
            updateAddNewUserPayload,
            fetchAccounts,
            fetchClientsByAccount,
            fetchRoles
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddUser));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SignUp/screens/AddUser/index.js